import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21d5787b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=21d5787b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5787b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d5787b')) {
      api.createRecord('21d5787b', component.options)
    } else {
      api.reload('21d5787b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21d5787b&scoped=true", function () {
      api.rerender('21d5787b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/module/index.vue"
export default component.exports